module.exports = __webpack_public_path__ + "static/img/resume-cool.ab886b2.png";